export default __webpack_public_path__ + "static/media/Easter bunny wreath_primary.0f1221e2.jpg";